import React, { useEffect, useState } from "react";
import {
  Tabs,
  Modal,
  Input,
  Form,
  Upload,
  message,
  Select,
  Switch,
  Tag,
  DatePicker,
  Spin,
} from "antd";
import moment from "moment";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { getAuthReducer } from "../../../redux/Reducer/authReducer";
import axios from "axios";

const { RangePicker } = DatePicker;

const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
  }).format(value);
};

// Image compression utility
const compressImage = (file, maxWidth = 1200, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions while maintaining aspect ratio
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            } else {
              reject(new Error("Canvas to Blob conversion failed"));
            }
          },
          "image/jpeg",
          quality,
        );
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });
};

const createCat = {
  color: "#131523",
  textAlign: "center",
  fontFamily: '"MADE TOMMY"',
  fontSize: "24.101px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "33.742px",
};

const createCatDes = {
  color: "#5A607F",
  textAlign: "center",
  fontFamily: '"MADE TOMMY"',
  fontSize: "19.281px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "28.921px",
};

const createCatButton = {
  width: "209.68px",
  height: "48.202px",
  flexShrink: 0,
  borderRadius: "4.82px",
  background: "#252A4D",
};

const buttonText = {
  color: "#FFF",
  fontFamily: '"MADE TOMMY"',
  fontSize: "19.281px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "28.921px",
};

const readMore = {
  color: "#1E5EFF",
  textAlign: "center",
  fontFamily: '"MADE TOMMY"',
  fontSize: "19.281px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "28.921px",
};

const CategorySetup = () => {
  const [productTypes, setProductTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActiveKey] = useState("1");
  const [categoryItemCount, setCategoryItemCount] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [statusUpdateModalVisible, setStatusUpdateModalVisible] =
    useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isPromo, setIsPromo] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);
  const [uploadedImageUrls, setUploadedImageUrls] = useState([]);
  const [form] = Form.useForm();

  const { authUser } = useSelector(getAuthReducer);

  // Function to fetch product types
  const prodTypes = () => {
    const bearerToken = authUser.access_token;
    fetch(
      `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/product-types`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch product types");
        }
      })
      .then((data) => {
        setProductTypes(data.data);
        setLoading(false);
        if (data.length > 0) {
          setCategoryItemCount(data[0].products.length);
        }
      })
      .catch((error) => {
        console.error("Error fetching product types:", error);
        setLoading(false);
      });
  };

  // Fetch locations
  const fetchLocations = () => {
    const bearerToken = authUser.access_token;
    fetch(
      `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/locations`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((data) => setLocations(data.data))
      .catch((error) => {
        console.error("Error fetching locations:", error);
      });
  };

  // Fetch user types
  const fetchUserTypes = () => {
    const bearerToken = authUser.access_token;
    fetch(
      `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/user-types`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        const filteredUserTypes = data.data.filter(
          (userType) => userType.id === 3 || userType.id === 5,
        );
        setUserTypes(filteredUserTypes);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };

  useEffect(() => {
    prodTypes();
    fetchLocations();
    fetchUserTypes();

    if (selectedItem) {
      const promoStatus =
        selectedItem?.is_promo_product === 1 ||
        selectedItem?.is_promo_product === true;
      setIsPromo(promoStatus);

      // Set uploaded image URLs from existing product
      const existingImages = selectedItem?.images?.map((img) => img.url) || [];
      setUploadedImageUrls(existingImages);

      form.setFieldsValue({
        id: selectedItem?.id,
        categoryId: 2,
        productTypeId: selectedItem?.product_type_id,
        locationId: selectedItem?.location_id || null,
        userTypeId: selectedItem?.user_type_id || null,
        name: selectedItem?.name,
        description: selectedItem?.description,
        qty: selectedItem?.qty,
        amount: selectedItem?.amount,
        discount: selectedItem?.discount,
        images: selectedItem?.images?.map((img, index) => ({
          uid: `-${index}`,
          name: `image-${index}.png`,
          status: "done",
          url: img.url,
        })),
        is_promo_product: promoStatus,
        unit: selectedItem?.unit,
        promo_amount: selectedItem?.promo_amount,
        promo_duration:
          selectedItem?.start_date && selectedItem?.end_date
            ? [moment(selectedItem.start_date), moment(selectedItem.end_date)]
            : [],
      });
    } else {
      setIsPromo(false);
      setUploadedImageUrls([]);
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem, form]);

  const handleTabChange = (key) => {
    setActiveKey(key);
    const selectedProductType = productTypes.find(
      (pt) => pt.id.toString() === key,
    );
    if (selectedProductType) {
      setCategoryItemCount(selectedProductType.products.length);
    }
  };

  const handleAddNewItemClick = () => {
    setSelectedItem(null);
    setUploadedImageUrls([]);
    setModalVisible(true);
  };

  const handleEditItemClick = (item) => {
    setSelectedItem(item);
    setModalVisible(true);
  };

  const handleDeleteItemClick = (item) => {
    setSelectedItem(item);
    setDeleteModalVisible(true);
  };

  const handleDeleteModalCancel = () => {
    setDeleteModalVisible(false);
    setSelectedItem(null);
  };

  const handleStatusUpdateItemClick = (item) => {
    setSelectedItem(item);
    setStatusUpdateModalVisible(true);
  };

  const handleStatusUpdateModalCancel = () => {
    setStatusUpdateModalVisible(false);
    setSelectedItem(null);
  };

  const handleDeleteItem = (product_id) => {
    const bearerToken = authUser.access_token;
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    fetch(
      `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/products/${product_id}`,
      {
        method: "DELETE",
        headers: headers,
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(() => {
        const updatedProductTypes = productTypes.map((pt) => {
          if (pt.id.toString() === activeKey) {
            return {
              ...pt,
              CategoryItems: pt.CategoryItems.filter(
                (ci) => ci.id !== selectedItem.id,
              ),
            };
          }
          return pt;
        });
        setProductTypes(updatedProductTypes);
        setCategoryItemCount(categoryItemCount - 1);
        message.success("Product deleted successfully");
        prodTypes();
      })
      .catch((error) => {
        message.error("Error deleting product");
        prodTypes();
      });
    setDeleteModalVisible(false);
    setSelectedItem(null);
  };

  const props = {
    multiple: true,
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return Upload.LIST_IGNORE;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must be smaller than 2MB!");
        return Upload.LIST_IGNORE;
      }

      return false; // Prevent auto upload
    },
    onChange: async (info) => {
      // Filter out files that already have URLs (existing images)
      const newFiles = info.fileList.filter(
        (file) => !file.url && file.originFileObj,
      );

      if (newFiles.length === 0) return;

      setImageUploading(true);

      try {
        const uploadPromises = newFiles.map(async (file) => {
          // Compress image before upload
          let fileToUpload = file.originFileObj;
          try {
            // Only compress if it's an image
            if (file.originFileObj.type.startsWith("image/")) {
              const originalSize = file.originFileObj.size / 1024 / 1024; // MB
              console.log(`Original image size: ${originalSize.toFixed(2)} MB`);

              fileToUpload = await compressImage(file.originFileObj);

              const compressedSize = fileToUpload.size / 1024 / 1024; // MB
              console.log(
                `Compressed image size: ${compressedSize.toFixed(2)} MB`,
              );
              console.log(
                `Reduction: ${((1 - compressedSize / originalSize) * 100).toFixed(1)}%`,
              );
            }
          } catch (compressionError) {
            console.warn(
              "Compression failed, uploading original:",
              compressionError,
            );
            fileToUpload = file.originFileObj;
          }

          const formData = new FormData();
          formData.append("file", fileToUpload);
          formData.append(
            "upload_preset",
            process.env.REACT_APP_API_CLOUDINARY_PRESET_KEY,
          );

          const response = await axios.post(
            `${process.env.REACT_APP_API_CLOUDINARY_URL}/${process.env.REACT_APP_API_CLOUDINARY_CLOUD_NAME}/image/upload`,
            formData,
          );

          if (response.status === 200) {
            file.url = response.data.secure_url;
            return response.data.secure_url;
          }
          return null;
        });

        const newUrls = await Promise.all(uploadPromises);
        const validUrls = newUrls.filter((url) => url !== null);

        // Add new URLs to existing ones without duplicating
        setUploadedImageUrls((prev) => [...prev, ...validUrls]);

        message.success(`${validUrls.length} image(s) uploaded successfully`);
      } catch (err) {
        console.error("Error uploading image:", err);
        message.error("Failed to upload one or more images");
      } finally {
        setImageUploading(false);
      }
    },
    onRemove: (file) => {
      // Remove from uploaded URLs when user removes an image
      if (file.url) {
        setUploadedImageUrls((prev) => prev.filter((url) => url !== file.url));
      }
    },
  };

  const handleFormSubmit = async (values) => {
    // Check if images are still uploading
    if (imageUploading) {
      message.warning("Please wait for images to finish uploading");
      return;
    }

    // Check if we have any uploaded images
    if (uploadedImageUrls.length === 0) {
      message.error("Please upload at least one image");
      return;
    }

    try {
      const startDate =
        values.promo_duration && values.promo_duration[0]
          ? values.promo_duration[0].format("YYYY-MM-DD")
          : null;
      const endDate =
        values.promo_duration && values.promo_duration[1]
          ? values.promo_duration[1].format("YYYY-MM-DD")
          : null;

      const submissionData = {
        product_type_id: values.productTypeId,
        location_id: values.locationId,
        user_type_id: values.userTypeId,
        category_id: values.categoryId,
        name: values.name,
        description: values.description,
        qty: 0,
        amount: values.amount,
        discount: values.discount,
        images: uploadedImageUrls.map((url) => ({ url })),
        is_promo_product: values.is_promo_product,
        unit: values.is_promo_product ? values.unit : null,
        promo_amount: values.is_promo_product ? values.promo_amount : null,
        start_date: values.is_promo_product ? startDate : null,
        end_date: values.is_promo_product ? endDate : null,
      };

      const url = selectedItem
        ? `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/products/${values?.id}`
        : `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/products`;

      const bearerToken = authUser.access_token;
      const headers = {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      const method = selectedItem ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: headers,
        body: JSON.stringify(submissionData),
      });

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.message || "Failed to update the product");

      message.success(
        `Product ${selectedItem ? "updated" : "added"} successfully`,
      );
      setModalVisible(false);
      setUploadedImageUrls([]);
      form.resetFields();
      prodTypes();
    } catch (error) {
      console.error("Error:", error);
      message.error(`Error: ${error.message}`);
    }
  };

  const handleDuplicateProduct = async (product) => {
    try {
      const duplicateProductData = {
        product_type_id: product.product_type_id,
        location_id: Array.isArray(product.location_id)
          ? product.location_id
          : [product.location_id],
        user_type_id: product.user_type_id,
        category_id: product.category_id,
        name: `${product.name} - Copy`,
        description: product.description,
        qty: product.qty,
        amount: product.amount,
        discount: product.discount,
        images: product.images
          ? product.images.map((image) => ({ url: image.url }))
          : [],
        // Include promo details
        is_promo_product: product.is_promo_product,
        unit: product.is_promo_product ? product.unit : null,
        promo_amount: product.is_promo_product ? product.promo_amount : null,
        start_date: product.is_promo_product ? product.start_date : null,
        end_date: product.is_promo_product ? product.end_date : null,
      };

      const bearerToken = authUser.access_token;
      const headers = {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      const response = await fetch(
        `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/products`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(duplicateProductData),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to duplicate the product");
      }

      message.success(`Product duplicated successfully!`);
      prodTypes();
    } catch (error) {
      console.error("Error duplicating product:", error);
      message.error(`Error: ${error.message}`);
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const handleStatusUpdateItem = (product_id, status) => {
    try {
      const bearerToken = authUser.access_token;
      const headers = {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      let productStatus = status === 0 ? true : false;

      const requestBody = {
        product_id: product_id,
        status: productStatus,
      };

      fetch(
        `${window.location.hostname === "localhost" ? process.env.REACT_APP_API_BASE_LOCAL_URL : process.env.REACT_APP_API_BASE_DEV_URL}/products/status`,
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(requestBody),
        },
      );

      message.success(
        `Product ${productStatus ? "activated " : "deactivated "} successfully`,
      );
      prodTypes();
    } catch (error) {
      console.error("Error updating product status:", error);
    }
    setStatusUpdateModalVisible(false);
    setSelectedItem(null);
  };

  const items = productTypes.map((productType) => ({
    key: productType.id.toString(),
    label: productType.name,
    children: (
      <div
        className="product-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "16px",
          padding: "10px 0",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "250px",
            height: "405px",
            flexShrink: 0,
            borderRadius: "8px",
            border: "1px dashed #2F355B",
            background: "#F9F9F9",
            cursor: "pointer",
            justifySelf: "center",
          }}
          onClick={handleAddNewItemClick}
        >
          <div
            className="text-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              height: "100%",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "24px",
                background: "#E5E5E5",
              }}
            >
              +
            </div>
            <div
              style={{
                color: "#2F355B",
                textAlign: "center",
                fontFamily: '"MADE TOMMY"',
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "140%",
              }}
            >
              Add new Item
            </div>
          </div>
        </div>
        {productType.products.map((item, i) => {
          const isPromo = item.is_promo_product === true;

          return (
            <div
              key={i}
              style={{
                width: "100%",
                maxWidth: "250px",
                height: "405px",
                flexShrink: 0,
                borderRadius: "8px",
                border: isPromo ? "2px solid #D4AF37" : "1px solid #393C49",
                background: "#F9F9F9",
                paddingBottom: "0px",
                backgroundColor:
                  item.status === 1 ? "#F9F9F9" : "rgba(250, 95, 95, 0.08)",
                position: "relative",
                justifySelf: "center",
                marginBottom: "20px",
              }}
            >
              {isPromo && (
                <div
                  style={{
                    position: "absolute",
                    top: "12px",
                    left: "0",
                    backgroundColor: "#D4AF37",
                    color: "white",
                    padding: "2px 8px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    borderRadius: "0 4px 4px 0",
                    zIndex: 10,
                    boxShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                  }}
                >
                  PROMO
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "50%",
                }}
              >
                <img
                  src={item?.images[0]?.url}
                  alt={item?.name}
                  style={{
                    width: "143.945px",
                    height: "143.945px",
                    borderRadius: "50%",
                    border: isPromo ? "2px solid #D4AF37" : "none",
                  }}
                  className="mt-0"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: "56%",
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{ height: "auto", width: "100%", textAlign: "center" }}
                >
                  <div
                    style={{
                      color: "#2F355B",
                      fontFamily: '"MADE TOMMY"',
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "12px",
                    }}
                  >
                    {item.name}
                  </div>

                  <div
                    className="mb-0"
                    style={{
                      color: "#727272",
                      fontFamily: '"MADE TOMMY"',
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "140%",
                      marginBottom: "5px",
                    }}
                  >
                    {isPromo ? (
                      <span
                        style={{
                          textDecoration: "line-through",
                          fontSize: "12px",
                          marginRight: "5px",
                        }}
                      >
                        {formatCurrency(+Number(item?.amount ?? 0).toFixed(2))}
                      </span>
                    ) : (
                      formatCurrency(
                        +Number(item?.amount ?? 0).toFixed(2) || 0.0,
                      )
                    )}
                  </div>

                  {isPromo && (
                    <div
                      style={{
                        color: "#D4AF37",
                        fontWeight: "bold",
                        fontSize: "13px",
                        marginBottom: "8px",
                      }}
                    >
                      Bundle Deal: {item.unit} for{" "}
                      {formatCurrency(+Number(item?.promo_amount ?? 0))}
                    </div>
                  )}

                  <div className="mb-2 text-center mb-2">
                    {locations
                      .filter((loc) => loc.id === item.location_id)
                      .map((location) => {
                        const userType = userTypes.find(
                          (ut) => ut.id === item.user_type_id,
                        );
                        return (
                          <Tag
                            key={location.id}
                            color="blue"
                            style={{ fontSize: "10px", margin: "2px" }}
                          >
                            {location.name} -{" "}
                            {userType ? userType.name : "Unknown"}
                          </Tag>
                        );
                      })}

                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                      <button
                        className="mb-2"
                        style={{
                          backgroundColor: "#2F355B",
                          color: "#FFF",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                        }}
                        onClick={() => handleDuplicateProduct(item)}
                      >
                        Duplicate
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    width: "250px",
                    height: "52px",
                    flexShrink: 0,
                    borderRadius: "0px 0px 8px 8px",
                    background: "#2F355B",
                    marginBottom: "0px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <EditOutlined
                    style={{
                      color: "#FFF",
                      fontSize: "16px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleEditItemClick(item)}
                  />

                  <DeleteOutlined
                    style={{
                      color: "#FFF",
                      fontSize: "16px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeleteItemClick(item)}
                  />

                  <Switch
                    checked={item.status}
                    onChange={() => handleStatusUpdateItemClick(item)}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    style={{
                      backgroundColor: item.status ? "#52c41a" : "#ff4d4f",
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    ),
  }));

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <style>
        {`
          @media (max-width: 1400px) {
            .product-grid {
              grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)) !important;
            }
          }
          
          @media (max-width: 1200px) {
            .product-grid {
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)) !important;
            }
          }
          
          @media (max-width: 992px) {
            .product-grid {
              grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)) !important;
            }
          }
          
          @media (max-width: 768px) {
            .product-grid {
              grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)) !important;
            }
          }
          
          @media (max-width: 576px) {
            .product-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
      <div className="container">
        <div
          style={{
            color: "#45464E",
            fontFamily: '"MADE TOMMY"',
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "normal",
          }}
          className="mt-5 mb-3"
        >
          Product Set-up
          <span
            style={{
              padding: "4px 12px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "30px",
              background: "rgba(37, 42, 77, 0.08)",
              color: "#252A4D",
              fontFamily: '"Open Sans"',
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "18px",
            }}
            className="mx-2"
          >
            {categoryItemCount}
          </span>
        </div>
        {productTypes.length === 0 ? (
          <div className="text-center">
            <div
              className="my-3"
              style={{
                marginTop: "200px",
              }}
            >
              {/* SVG content */}
            </div>
            <div className="my-3" style={createCat}>
              Create your product categories
            </div>
            <div className="my-3" style={createCatDes}>
              Once you create a category, you can add products to it.
            </div>
            <button style={createCatButton}>
              <div className="my-1" style={buttonText}>
                Create Category
              </div>
            </button>
            <div className="my-3" style={readMore}>
              Learn More
            </div>
          </div>
        ) : (
          <Tabs
            type="card"
            size="large"
            items={items}
            onChange={handleTabChange}
            activeKey={activeKey}
          />
        )}
      </div>

      <Modal
        title={selectedItem ? "Edit Product" : "Add Product"}
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setUploadedImageUrls([]);
        }}
        onOk={() => form.submit()}
        okText={selectedItem ? "Update Product" : "Add Product"}
        cancelText="Cancel"
        width={800}
        okButtonProps={{ disabled: imageUploading }}
      >
        <Form form={form} onFinish={handleFormSubmit} layout="vertical">
          <Form.Item name="id" label="id" hidden>
            <Input />
          </Form.Item>

          <div className="row">
            <div className="col">
              <Form.Item
                name="productTypeId"
                label="Product Category"
                rules={[
                  {
                    required: true,
                    message: "Please select a product category!",
                  },
                ]}
              >
                <Select placeholder="Select a product category">
                  {productTypes.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col">
              <Form.Item
                name="locationId"
                label="Location"
                rules={[
                  {
                    required: true,
                    message: "Please select one or more locations!",
                  },
                ]}
              >
                <Select mode="multiple" placeholder="Select locations">
                  {locations.map((location) => (
                    <Select.Option key={location.id} value={location.id}>
                      {location.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col">
              <Form.Item
                name="userTypeId"
                label="User Type"
                rules={[
                  { required: true, message: "Please select a user type!" },
                ]}
              >
                <Select placeholder="Select a user type">
                  {userTypes.map((userType) => (
                    <Select.Option key={userType.id} value={userType.id}>
                      {userType.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <Form.Item
            name="name"
            label="Name"
            rules={[
              { required: true, message: "Please enter the product name!" },
            ]}
          >
            <Input placeholder="Product Name" />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: "Please enter the product description!",
              },
            ]}
          >
            <Input.TextArea rows={4} placeholder="Description" />
          </Form.Item>

          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              { required: true, message: "Please enter the product amount!" },
            ]}
          >
            <Input type="number" placeholder="Amount" />
          </Form.Item>

          <Form.Item name="discount" label="Discount (%)">
            <Input type="number" placeholder="Discount" />
          </Form.Item>

          <div
            style={{
              background: "#f9f9f9",
              padding: "15px",
              borderRadius: "8px",
              marginBottom: "20px",
            }}
          >
            <Form.Item
              name="is_promo_product"
              label="Is this a Promo Product?"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="Yes"
                unCheckedChildren="No"
                onChange={(checked) => setIsPromo(checked)}
              />
            </Form.Item>

            {isPromo && (
              <div className="row">
                <div className="col-md-4">
                  <Form.Item
                    name="unit"
                    label="Bundle Quantity (Fixed)"
                    rules={[
                      { required: isPromo, message: "Enter bundle quantity" },
                    ]}
                    help="The fixed number of items in this deal."
                  >
                    <Input type="number" placeholder="e.g. 20" />
                  </Form.Item>
                </div>
                <div className="col-md-4">
                  <Form.Item
                    name="promo_amount"
                    label="Total Bundle Price"
                    rules={[
                      {
                        required: isPromo,
                        message: "Enter total bundle price",
                      },
                    ]}
                    help="The total price for the specific quantity above."
                  >
                    <Input type="number" placeholder="e.g. 25000" />
                  </Form.Item>
                </div>
                <div className="col-md-4">
                  <Form.Item
                    name="promo_duration"
                    label="Promo Duration"
                    rules={[{ required: isPromo, message: "Select dates" }]}
                  >
                    <RangePicker style={{ width: "100%" }} />
                  </Form.Item>
                </div>
              </div>
            )}
          </div>

          <Form.Item
            name="images"
            label={
              <span>
                Upload Images
                {imageUploading && (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 14, marginLeft: 8 }}
                        spin
                      />
                    }
                    style={{ marginLeft: 8 }}
                  />
                )}
              </span>
            }
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[
              { required: true, message: "Please upload product images!" },
            ]}
            extra={
              imageUploading
                ? "Uploading images, please wait..."
                : "Select multiple images"
            }
          >
            <Upload
              {...props}
              listType="picture-card"
              beforeUpload={() => false}
            >
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </Form.Item>

          {imageUploading && (
            <div
              style={{
                textAlign: "center",
                padding: "10px",
                background: "#e6f7ff",
                borderRadius: "4px",
                marginBottom: "15px",
              }}
            >
              <LoadingOutlined style={{ fontSize: 20, marginRight: 10 }} />
              <span>
                Uploading images... Please wait before submitting the form.
              </span>
            </div>
          )}
        </Form>
      </Modal>

      <Modal
        title="Delete Product"
        visible={deleteModalVisible}
        onCancel={handleDeleteModalCancel}
        onOk={() => handleDeleteItem(selectedItem.id)}
        okText="Delete"
        cancelText="Cancel"
      >
        <p>Are you sure you want to delete this product?</p>
      </Modal>

      <Modal
        title="Update Product Status"
        visible={statusUpdateModalVisible}
        onCancel={handleStatusUpdateModalCancel}
        onOk={() =>
          handleStatusUpdateItem(selectedItem.id, selectedItem.status)
        }
        okText="Yes"
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to{" "}
          {selectedItem?.status ? "deactivate " : "activate "}
          this product?
        </p>
      </Modal>
    </>
  );
};

export default CategorySetup;
